import { render, staticRenderFns } from "./vsAlert.vue?vue&type=template&id=3e9510de&lang=html"
import script from "./vsAlert.vue?vue&type=script&lang=js"
export * from "./vsAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports